import { render, staticRenderFns } from "./NewPresentationButtonV2.vue?vue&type=template&id=8302774c&scoped=true"
import script from "./NewPresentationButtonV2.vue?vue&type=script&lang=js"
export * from "./NewPresentationButtonV2.vue?vue&type=script&lang=js"
import style0 from "./NewPresentationButtonV2.vue?vue&type=style&index=0&id=8302774c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8302774c",
  null
  
)

export default component.exports